"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorWarning = exports.colorTooltipFill = exports.colorTextWarning = exports.colorTextTertiary = exports.colorTextSuccess = exports.colorTextSecondary = exports.colorTextPrimary = exports.colorTextNeutral = exports.colorTextInverseSecondary = exports.colorTextInversePrimary = exports.colorTextInformation = exports.colorTextFavorite = exports.colorTextDisabled = exports.colorTextDanger = exports.colorTextClickable = exports.colorSuccessLightest = exports.colorSuccessLight = exports.colorSuccessDarkest = exports.colorSuccessDark = exports.colorSuccess = exports.colorSubMenuStar = exports.colorSubMenuBackgroundDefault = exports.colorSideMenuIconDefault = exports.colorSideMenuIconActive = exports.colorSideMenuBackgroundSelected = exports.colorSideMenuBackgroundHovered = exports.colorSideMenuBackgroundDefault = exports.colorSideMenuAccountBarFill = exports.colorScoreBarLevel5 = exports.colorScoreBarLevel4 = exports.colorScoreBarLevel3 = exports.colorScoreBarLevel2 = exports.colorScoreBarLevel1 = exports.colorScoreBarInactive = exports.colorNeutralLightest = exports.colorNeutralLight = exports.colorNeutralDarkest = exports.colorNeutralDark = exports.colorNeutral = exports.colorInformationLightest = exports.colorInformationLight = exports.colorInformationDarkest = exports.colorInformationDark = exports.colorInformation = exports.colorIconSecondary = exports.colorIconPrimary = exports.colorGroupMenuTextDefault = exports.colorGroupMenuBackgroundSelected = exports.colorGroupMenuBackgroundHovered = exports.colorGroupMenuBackgroundDefault = exports.colorGrayLightest = exports.colorFocusSecondary = exports.colorFocusPrimary = exports.colorFocusDanger = exports.colorFillSecondary = exports.colorFillPrimary = exports.colorFillNone = exports.colorFillInversePrimary = exports.colorFillDisabled = exports.colorDataViz8 = exports.colorDataViz7 = exports.colorDataViz6 = exports.colorDataViz5 = exports.colorDataViz4 = exports.colorDataViz3 = exports.colorDataViz2 = exports.colorDataViz1 = exports.colorDangerLightest = exports.colorDangerLight = exports.colorDangerDarkest = exports.colorDangerDark = exports.colorDanger = exports.colorButtonFillTertiaryPressed = exports.colorButtonFillTertiaryHovered = exports.colorButtonFillTertiaryEnabled = exports.colorButtonFillTableActionPressed = exports.colorButtonFillTableActionHovered = exports.colorButtonFillTableActionEnabled = exports.colorButtonFillTableActionBorder = exports.colorButtonFillSecondaryPressed = exports.colorButtonFillSecondaryHovered = exports.colorButtonFillSecondaryEnabled = exports.colorButtonFillPrimaryPressed = exports.colorButtonFillPrimaryHovered = exports.colorButtonFillPrimaryEnabled = exports.colorButtonFillGhostPressed = exports.colorButtonFillGhostHovered = exports.colorButtonFillGhostEnabled = exports.colorButtonFillDangerPressed = exports.colorButtonFillDangerHovered = exports.colorButtonFillDangerEnabled = exports.colorBorderTertiary = exports.colorBorderSecondary = exports.colorBorderPrimary = exports.colorBorderDanger = exports.colorBackgroundTertiary = exports.colorBackgroundSecondary = exports.colorBackgroundPrimary = exports.colorBackgroundBrand = exports.colorBackdropFill = void 0;
exports.colorWarningLightest = exports.colorWarningLight = exports.colorWarningDarkest = exports.colorWarningDark = void 0;

const colorTextPrimary = '#17172A';
exports.colorTextPrimary = colorTextPrimary;
const colorTextSecondary = '#565656';
exports.colorTextSecondary = colorTextSecondary;
const colorTextTertiary = '#7e7e7e';
exports.colorTextTertiary = colorTextTertiary;
const colorTextDisabled = '#d1d1d1';
exports.colorTextDisabled = colorTextDisabled;
const colorTextClickable = '#5c34cd';
exports.colorTextClickable = colorTextClickable;
const colorTextNeutral = '#706F9B';
exports.colorTextNeutral = colorTextNeutral;
const colorTextSuccess = '#026b37';
exports.colorTextSuccess = colorTextSuccess;
const colorTextInformation = '#0660da';
exports.colorTextInformation = colorTextInformation;
const colorTextWarning = '#9e5909';
exports.colorTextWarning = colorTextWarning;
const colorTextDanger = '#cf1945';
exports.colorTextDanger = colorTextDanger;
const colorTextInversePrimary = '#ffffff';
exports.colorTextInversePrimary = colorTextInversePrimary;
const colorTextInverseSecondary = '#9F9FBC';
exports.colorTextInverseSecondary = colorTextInverseSecondary;
const colorTextFavorite = '#DFBD0D';
exports.colorTextFavorite = colorTextFavorite;
const colorIconPrimary = '#8D8CAF';
exports.colorIconPrimary = colorIconPrimary;
const colorIconSecondary = '#3E3D55';
exports.colorIconSecondary = colorIconSecondary;
const colorBorderPrimary = '#e1e1e1';
exports.colorBorderPrimary = colorBorderPrimary;
const colorBorderSecondary = '#d1d1d1';
exports.colorBorderSecondary = colorBorderSecondary;
const colorBorderTertiary = '#AEAEAE';
exports.colorBorderTertiary = colorBorderTertiary;
const colorBorderDanger = '#e31c4c';
exports.colorBorderDanger = colorBorderDanger;
const colorBackgroundBrand = '#271656';
exports.colorBackgroundBrand = colorBackgroundBrand;
const colorBackgroundPrimary = '#fafafa';
exports.colorBackgroundPrimary = colorBackgroundPrimary;
const colorBackgroundSecondary = '#f4f4f4';
exports.colorBackgroundSecondary = colorBackgroundSecondary;
const colorBackgroundTertiary = '#ffffff';
exports.colorBackgroundTertiary = colorBackgroundTertiary;
const colorFocusPrimary = '#ccc0f0';
exports.colorFocusPrimary = colorFocusPrimary;
const colorFocusSecondary = '#5c34cd';
exports.colorFocusSecondary = colorFocusSecondary;
const colorFocusDanger = '#f6b9c8';
exports.colorFocusDanger = colorFocusDanger;
const colorFillPrimary = '#5c34cd';
exports.colorFillPrimary = colorFillPrimary;
const colorFillSecondary = '#efebfa';
exports.colorFillSecondary = colorFillSecondary;
const colorFillNone = 'rgba(255,255,255,0)';
exports.colorFillNone = colorFillNone;
const colorFillDisabled = '#f4f4f4';
exports.colorFillDisabled = colorFillDisabled;
const colorFillInversePrimary = '#17172A';
exports.colorFillInversePrimary = colorFillInversePrimary;
const colorTooltipFill = 'rgba(23, 23, 42, 0.95)';
exports.colorTooltipFill = colorTooltipFill;
const colorBackdropFill = 'rgba(23, 23, 42, 0.7)';
exports.colorBackdropFill = colorBackdropFill;
const colorButtonFillTableActionEnabled = '#542fbb';
exports.colorButtonFillTableActionEnabled = colorButtonFillTableActionEnabled;
const colorButtonFillTableActionHovered = '#412592';
exports.colorButtonFillTableActionHovered = colorButtonFillTableActionHovered;
const colorButtonFillTableActionPressed = '#412592';
exports.colorButtonFillTableActionPressed = colorButtonFillTableActionPressed;
const colorButtonFillTableActionBorder = '#7d5dd7';
exports.colorButtonFillTableActionBorder = colorButtonFillTableActionBorder;
const colorButtonFillPrimaryEnabled = '#5c34cd';
exports.colorButtonFillPrimaryEnabled = colorButtonFillPrimaryEnabled;
const colorButtonFillPrimaryHovered = '#412592';
exports.colorButtonFillPrimaryHovered = colorButtonFillPrimaryHovered;
const colorButtonFillPrimaryPressed = '#412592';
exports.colorButtonFillPrimaryPressed = colorButtonFillPrimaryPressed;
const colorButtonFillSecondaryEnabled = '#efebfa';
exports.colorButtonFillSecondaryEnabled = colorButtonFillSecondaryEnabled;
const colorButtonFillSecondaryHovered = '#ccc0f0';
exports.colorButtonFillSecondaryHovered = colorButtonFillSecondaryHovered;
const colorButtonFillSecondaryPressed = '#ccc0f0';
exports.colorButtonFillSecondaryPressed = colorButtonFillSecondaryPressed;
const colorButtonFillTertiaryEnabled = '#ffffff';
exports.colorButtonFillTertiaryEnabled = colorButtonFillTertiaryEnabled;
const colorButtonFillTertiaryHovered = '#EBEBEB';
exports.colorButtonFillTertiaryHovered = colorButtonFillTertiaryHovered;
const colorButtonFillTertiaryPressed = '#EBEBEB';
exports.colorButtonFillTertiaryPressed = colorButtonFillTertiaryPressed;
const colorButtonFillGhostEnabled = 'rgba(255,255,255,0)';
exports.colorButtonFillGhostEnabled = colorButtonFillGhostEnabled;
const colorButtonFillGhostHovered = '#EBEBEB';
exports.colorButtonFillGhostHovered = colorButtonFillGhostHovered;
const colorButtonFillGhostPressed = '#EBEBEB';
exports.colorButtonFillGhostPressed = colorButtonFillGhostPressed;
const colorButtonFillDangerEnabled = '#e31c4c';
exports.colorButtonFillDangerEnabled = colorButtonFillDangerEnabled;
const colorButtonFillDangerHovered = '#cf1945';
exports.colorButtonFillDangerHovered = colorButtonFillDangerHovered;
const colorButtonFillDangerPressed = '#cf1945';
exports.colorButtonFillDangerPressed = colorButtonFillDangerPressed;
const colorSideMenuBackgroundDefault = '#17172A';
exports.colorSideMenuBackgroundDefault = colorSideMenuBackgroundDefault;
const colorSideMenuBackgroundHovered = '#1F1F36';
exports.colorSideMenuBackgroundHovered = colorSideMenuBackgroundHovered;
const colorSideMenuBackgroundSelected = '#5c34cd';
exports.colorSideMenuBackgroundSelected = colorSideMenuBackgroundSelected;
const colorSideMenuIconDefault = '#9F9FBC';
exports.colorSideMenuIconDefault = colorSideMenuIconDefault;
const colorSideMenuIconActive = '#ffffff';
exports.colorSideMenuIconActive = colorSideMenuIconActive;
const colorSideMenuAccountBarFill = '#1F1F36';
exports.colorSideMenuAccountBarFill = colorSideMenuAccountBarFill;
const colorGroupMenuBackgroundDefault = '#17172A';
exports.colorGroupMenuBackgroundDefault = colorGroupMenuBackgroundDefault;
const colorGroupMenuBackgroundHovered = '#1F1F36';
exports.colorGroupMenuBackgroundHovered = colorGroupMenuBackgroundHovered;
const colorGroupMenuBackgroundSelected = '#5c34cd';
exports.colorGroupMenuBackgroundSelected = colorGroupMenuBackgroundSelected;
const colorGroupMenuTextDefault = '#D3D2E0';
exports.colorGroupMenuTextDefault = colorGroupMenuTextDefault;
const colorSubMenuBackgroundDefault = '#1F1F36';
exports.colorSubMenuBackgroundDefault = colorSubMenuBackgroundDefault;
const colorSubMenuStar = '#DFBD0D';
exports.colorSubMenuStar = colorSubMenuStar;
const colorDataViz1 = '#8dbaf8';
exports.colorDataViz1 = colorDataViz1;
const colorDataViz2 = '#b4a2e8';
exports.colorDataViz2 = colorDataViz2;
const colorDataViz3 = '#8bcfad';
exports.colorDataViz3 = colorDataViz3;
const colorDataViz4 = '#f0c48f';
exports.colorDataViz4 = colorDataViz4;
const colorDataViz5 = '#f297ad';
exports.colorDataViz5 = colorDataViz5;
const colorDataViz6 = '#B0F0E3';
exports.colorDataViz6 = colorDataViz6;
const colorDataViz7 = '#F5B8E1';
exports.colorDataViz7 = colorDataViz7;
const colorDataViz8 = '#F5EBB4';
exports.colorDataViz8 = colorDataViz8;
const colorScoreBarLevel1 = '#7e7e7e';
exports.colorScoreBarLevel1 = colorScoreBarLevel1;
const colorScoreBarLevel2 = '#e94970';
exports.colorScoreBarLevel2 = colorScoreBarLevel2;
const colorScoreBarLevel3 = '#e5983d';
exports.colorScoreBarLevel3 = colorScoreBarLevel3;
const colorScoreBarLevel4 = '#3987f3';
exports.colorScoreBarLevel4 = colorScoreBarLevel4;
const colorScoreBarLevel5 = '#35ab71';
exports.colorScoreBarLevel5 = colorScoreBarLevel5;
const colorScoreBarInactive = '#d1d1d1';
exports.colorScoreBarInactive = colorScoreBarInactive;
const colorGrayLightest = '#EBEBEB';
exports.colorGrayLightest = colorGrayLightest;
const colorNeutral = '#706F9B';
exports.colorNeutral = colorNeutral;
const colorNeutralLightest = '#f1f1f5';
exports.colorNeutralLightest = colorNeutralLightest;
const colorNeutralLight = '#D3D2E0';
exports.colorNeutralLight = colorNeutralLight;
const colorNeutralDark = '#504F6E';
exports.colorNeutralDark = colorNeutralDark;
const colorNeutralDarkest = '#2C2C47';
exports.colorNeutralDarkest = colorNeutralDarkest;
const colorSuccess = '#03964d';
exports.colorSuccess = colorSuccess;
const colorSuccessLightest = '#e6f5ed';
exports.colorSuccessLightest = colorSuccessLightest;
const colorSuccessLight = '#8bcfad';
exports.colorSuccessLight = colorSuccessLight;
const colorSuccessDark = '#026b37';
exports.colorSuccessDark = colorSuccessDark;
const colorSuccessDarkest = '#013f20';
exports.colorSuccessDarkest = colorSuccessDarkest;
const colorInformation = '#0769f0';
exports.colorInformation = colorInformation;
const colorInformationLightest = '#e6f0fe';
exports.colorInformationLightest = colorInformationLightest;
const colorInformationLight = '#8dbaf8';
exports.colorInformationLight = colorInformationLight;
const colorInformationDark = '#054baa';
exports.colorInformationDark = colorInformationDark;
const colorInformationDarkest = '#032c65';
exports.colorInformationDarkest = colorInformationDarkest;
const colorWarning = '#df7e0c';
exports.colorWarning = colorWarning;
const colorWarningLightest = '#fcf2e7';
exports.colorWarningLightest = colorWarningLightest;
const colorWarningLight = '#f0c48f';
exports.colorWarningLight = colorWarningLight;
const colorWarningDark = '#9e5909';
exports.colorWarningDark = colorWarningDark;
const colorWarningDarkest = '#5e3505';
exports.colorWarningDarkest = colorWarningDarkest;
const colorDanger = '#e31c4c';
exports.colorDanger = colorDanger;
const colorDangerLightest = '#fce8ed';
exports.colorDangerLightest = colorDangerLightest;
const colorDangerLight = '#f297ad';
exports.colorDangerLight = colorDangerLight;
const colorDangerDark = '#a11436';
exports.colorDangerDark = colorDangerDark;
const colorDangerDarkest = '#5f0c20';
exports.colorDangerDarkest = colorDangerDarkest;